export const load = () => ({
	title: 'How to Easily Seal Windows for the Winter Months',
	showTitle: true,
});
